module.exports = __webpack_public_path__ + "dashboard.png?7c7edeed4f3ef0c1fdd72514483f6340";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashboard.png
// module id = 732
// module chunks = 0